import Image from "next/image";
import React from "react";

const POPULAR_DESTINATIONS = [
  {
    src: "/images/j.jpg",
    alt: "japan",
    label: "japan",
    labelClass: "top-2 left-2",
  },
  {
    src: "/images/c.jpg",
    alt: "canada",
    label: "canada",
    labelClass: "top-4 right-2",
  },
  {
    src: "/images/d.jpg",
    alt: "Dubai",
    label: "Dubai",
    labelClass: "top-1/3 left-2",
  },
  {
    src: "/images/l.jpg",
    alt: "london",
    label: "london",
    labelClass: "top-4 right-2",
  },
  {
    src: "/images/s.jpg",
    alt: "Singapore",
    label: "Singapore",
    labelClass: "top-2 left-2",
  },
];

const PopularDealsAndLatestBlogsSections = ({
  router,
  latestBlogs,
  hidePopularHeading = false,
}) => {
  const blogsToShow = (latestBlogs || []).slice(0, 10);
  const needsBlogScroll = blogsToShow.length >= 10;

  return (
    <>
      {/* Sticky until article / FAQ — original image heights (h-52) kept */}
      <section
        className="sticky top-24 z-10 max-w-70 bg-page-white"
        aria-labelledby="blog-detail-popular-deals"
      >
        {hidePopularHeading ? null : (
          <div id="blog-detail-popular-deals" className="text-black font-medium">
            Popular deals
          </div>
        )}
        <div
          role="button"
          tabIndex={0}
          onClick={() => router.push("/tours")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              router.push("/tours");
            }
          }}
          className={`flex flex-col rounded-lg overflow-hidden cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FBBC05] focus-visible:ring-offset-2 ${
            hidePopularHeading ? "mt-0" : "mt-3"
          }`}
          aria-label="Popular deals - Go to search"
        >
          {POPULAR_DESTINATIONS.map((d) => (
            <div key={d.src} className="relative w-full h-52 overflow-hidden">
              <Image
                src={d.src}
                alt={d.alt}
                fill
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 280px"
                className="w-full h-52 object-cover object-center"
              />
              <span
                className={`uppercase font-(family-name:--font-oswald) text-white absolute ${d.labelClass}`}
              >
                {d.label}
              </span>
            </div>
          ))}
        </div>
      </section>

      {/* Above sticky images so it isn’t covered while scrolling */}
      {blogsToShow.length ? (
        <section
          className="relative z-20 max-w-70 mt-10 bg-page-white pt-2"
          aria-labelledby="blog-detail-latest-blogs"
        >
          <div id="blog-detail-latest-blogs" className="text-black font-medium">
            Latest Blogs
          </div>
          <div
            className={
              needsBlogScroll
                ? "mt-3 max-h-[min(720px,calc(100vh-10rem))] space-y-4 overflow-y-auto overflow-x-hidden overscroll-y-contain pb-1 pr-1 scrollbar-gutter-stable"
                : "mt-3 space-y-4 pb-1"
            }
          >
            {blogsToShow.map((lb) => (
              <div
                key={lb.id}
                role="button"
                tabIndex={0}
                onClick={() =>
                  router.push(`/blog/${encodeURIComponent(String(lb.id))}`)
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    router.push(`/blog/${encodeURIComponent(String(lb.id))}`);
                  }
                }}
                className="group relative h-52 min-h-52 overflow-hidden rounded-3xl border border-gray-200 bg-gray-100 shadow-[0_10px_30px_rgba(0,0,0,0.10)] cursor-pointer"
              >
                <Image
                  src={lb.image}
                  alt={lb.title}
                  fill
                  className="absolute inset-0 h-full w-full object-cover"
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                />
                <div className="absolute inset-0 bg-linear-to-t from-black/70 via-black/20 to-transparent" />

                <div className="relative h-full p-4 flex flex-col justify-end">
                  <div className="text-white">
                    <div className="text-[15px] font-semibold leading-snug line-clamp-2">
                      {lb.title}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      ) : null}
    </>
  );
};

export default PopularDealsAndLatestBlogsSections;
